import request from '@/api/request'

//文件上传
export function uploadFile(data) {
    return request({
        url: '/api/uploadFiles/upload',
        method: 'POST',
        data
    })
}


//人才主页信息
export function memberInfo(data) {
    return request({
        url: '/web/member/info',
        method: 'GET',
        params: data
    })
}

//支付校验接口
export function checkPay(data) {
    return request({
        url: '/web/pay/isPay',
        method: 'GET',
        params: data
    })
}

//人才列表
//http://www.jianzhibei.local/api/purview/talent/getTalent?type=1&user_type=2&class_id=1
export function getTalent(data) {
    return request({
        url: '/api/purview/talent/getTalent',
        method: 'GET',
        params: data
    })
}

//http://www.jianzhibei.local/api/director/purview/postPurview
//设置权限
export function postPurview(data) {
    return request({
        url: '/api/director/purview/postPurview',
        method: 'POST',
         data
    })
}

//查询权限
//http://www.jianzhibei.local/api/purview/getPurview?type=2&limit=&page=
export function getPurview(data) {
    return request({
        url: '/api/purview/getPurview',
        method: 'GET',
        params: data
    })
}
